import React from "react";
import { Link } from "gatsby";
import { setEnglishLanguagePreference } from "../JapanGeoRedirect";

const JapanFooter = () => {
  return (
    <footer id="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row footer-container">
            <div className="col-lg-4 col-md-6 footer-info">
              <h5>Koderbox Japan</h5>
              <p>
                Koderboxは、オンラインで学べる日本語コース・英会話コースを提供しています。
                経験豊富な講師によるライブ授業と、少人数制クラスで、初心者から安心して学習を進められます。
                個人の方はもちろん、企業向けの語学研修にも対応しています。
              </p>
            </div>

            <div className="col-lg-2 col-md-6 footer-links">
              <h4>コース</h4>
              <ul>
                <li>
                  <a href="/jp/#jl-courses">日本語コース</a>
                </li>
                <li>
                  <a href="/jp/#jl-courses">英会話コース</a>
                </li>
                <li>
                  <Link to="/jp/corporate/">法人・企業向け研修</Link>
                </li>
              </ul>
            </div>

            <div className="col-lg-2 col-md-6 footer-links">
              <h4>リンク</h4>
              <ul>
                <li>
                  <Link to="/termsofservice/">利用規約</Link>
                </li>
                <li>
                  <Link to="/privacypolicy/">プライバシーポリシー</Link>
                </li>
                <li>
                  <Link to="/refundpolicy/">キャンセル・返金ポリシー</Link>
                </li>
                <li>
                  <a href="/" onClick={setEnglishLanguagePreference}>🇬🇧 English Site</a>
                </li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 footer-contact">
              <h4>お問い合わせ</h4>
              <p>
                <strong>Email:</strong> admin@koderbox.com <br />
                <strong>Phone:</strong> +91-9718214022 <br />
                <strong>WhatsApp:</strong> +91-9990484089 <br />
              </p>

              <div className="social-links">
                <a href="https://twitter.com/koderbox" className="twitter">
                  <i className="fa fa-twitter"></i>
                </a>
                <a href="https://www.facebook.com/koderbox" className="facebook">
                  <i className="fa fa-facebook"></i>
                </a>
                <a href="https://www.instagram.com/koderbox/" className="instagram">
                  <i className="fa fa-instagram"></i>
                </a>
                <a href="https://www.linkedin.com/company/koderbox/" className="linkedin">
                  <i className="fa fa-linkedin"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="copyright">
          &copy; Copyright <strong>Koderbox</strong>. All Rights Reserved
        </div>
      </div>
    </footer>
  );
};

export default JapanFooter;
